import { render, staticRenderFns } from "./diffValueItem.vue?vue&type=template&id=2309b960&scoped=true"
import script from "./diffValueItem.vue?vue&type=script&lang=js"
export * from "./diffValueItem.vue?vue&type=script&lang=js"
import style0 from "./diffValueItem.vue?vue&type=style&index=0&id=2309b960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309b960",
  null
  
)

export default component.exports